import { getLocationLabel } from '#src/app/shared/utils/location';

/** The petition fields the Constituents-in-PSF screens and `$exposure` read, on both the combo and share pages. */
export type ConstituentPsfPetition = Readonly<{
	relevantLocationLocalizedName: string | null;
	decisionMakersConnection: Readonly<{
		nodes: ReadonlyArray<Readonly<{ displayName?: string | null }>>;
		edges: ReadonlyArray<
			Readonly<{ associationData?: Readonly<{ constituentCountAmongSigners?: number | null }> | null }>
		>;
	}>;
}>;

/**
 * The screens refer to the decision maker generically as "[location] leaders" (CHANGE-101758). The
 * relevant location follows the petition's reach ("Nashville, TN" or "Tennessee, US"), and its leading
 * segment names that place, so a state petition shows the state, not a city. `undefined` lets the
 * screens fall back to "decision makers".
 */
export function getLocalSignerLocation(petition: ConstituentPsfPetition): string | undefined {
	return getLocationLabel(petition.relevantLocationLocalizedName);
}

/** Constituents among the petition's signers (the just-signed signer included), or 0 when unknown. */
export function getConstituentCount(petition: ConstituentPsfPetition): number {
	return petition.decisionMakersConnection.edges.at(0)?.associationData?.constituentCountAmongSigners ?? 0;
}

/**
 * The share screen's "You joined N other local signers" line. The count includes the signer, so
 * "other local signers" is one fewer; a missing or zero count degrades to the first-signer copy.
 */
export function getLocalSignerCounts(petition: ConstituentPsfPetition): {
	isFirstLocalSigner: boolean;
	otherSignerCount: number;
} {
	const count = getConstituentCount(petition);
	return { isFirstLocalSigner: count <= 1, otherSignerCount: Math.max(count - 1, 0) };
}
